export const COMPLETE_STEP = "upload/COMPLETE_STEP";
export const INIT_DATA_LOADED = "upload/INIT_DATA_LOADED";
export const LOCAL_STORAGE_LOADED = "upload/LOCAL_STORAGE_LOADED";
export const LOCAL_STORAGE_SYNCED = "upload/LOCAL_STORAGE_SYNCED";
export const SET_COVER_FILE = "uplaod/SET_COVER_FILE";
export const UPDATE_COVER_FILE = "upload/UPDATE_COVER_FILE";
export const SET_WORK_FILES = "upload/SET_WORK_FILES";
export const WORK_TYPE_FIELD_BLURRED = "upload/WORK_TYPE_FIELD_BLURRED";
export const UPLOAD_URLS_CREATED = "upload/UPLOAD_URLS_CREATED";
export const UPDATE_WORK_FILE = "upload/UPDATE_WORK_FILE";
export const UPDATE_WORK_FILES = "upload/UPDATE_WORK_FILES";

export const initDataLoaded = (documentMediumFormats, imageMediumFormats) => ({
  type: INIT_DATA_LOADED,
  documentMediumFormats,
  imageMediumFormats,
});

export const localStorageLoaded = (data) => ({
  type: LOCAL_STORAGE_LOADED,
  data,
});

export const localStorageSynced = () => ({ type: LOCAL_STORAGE_SYNCED });

export const setCoverFile = (file) => {
  return {
    type: SET_COVER_FILE,
    file,
  };
};

export const changeWorkFiles = (workFiles) => {
  return {
    type: SET_WORK_FILES,
    workFiles,
  };
};

export const updateWorkFileUploadProgress = (workFile, progress, status) => {
  return {
    type: UPDATE_WORK_FILE,
    workFile,
    progress,
    status,
  };
};

export const updateCoverFileUploadProgress = (progress, status) => {
  return {
    type: UPDATE_COVER_FILE,
    progress,
    status,
  };
};

export const updateWorkFiles = (workFiles) => {
  return {
    type: UPDATE_WORK_FILES,
    workFiles,
  };
};
